class VariantRemark extends HTMLElement {
  constructor() {
    super();
    this.init()
  }

  init() {
    const variants_data = JSON.parse(this.getAttribute('data-product'));
    const eles = this.querySelectorAll('.yg-remark')
    console.log(variants_data);
    document.addEventListener('variantChange', (event) => {
      const id = event.detail.variantObj;
      variants_data.forEach((item, index) => {
        if (item.id == id) {
          eles[index].classList.remove('hide');
          return
        }
        if (!item.classList?.contains('hide')) {
          eles[index].classList.add('hide');
        }
      })
    });
  }
}

if (!window.customElements.get('variant-remark')) {
  window.customElements.define('variant-remark', VariantRemark)
}

// function pageAnchor(hash) {
//   const number = Number(hash.replace(/#/g, ''));
//   const ygSectionList = document.querySelectorAll('.shopify-section');
//   const ele = ygSectionList[number + 1];
//   console.log(ele);
//   if (ele) {
//     let top = ele.offsetTop - 50
//     window.scrollTo({
//       top: top,
//       behavior: 'smooth',
//     });
//   }
// }

// setTimeout(() => {
//   pageAnchor(window.location.hash)
// }, 100)